import { useCallback } from 'react';
import { useRefreshOnPanelRestored } from './useRefreshOnPanelRestored';
import { useRefreshOnVisible } from './useRefreshOnVisible';
import { useRefreshOnWindowFocus } from './useRefreshOnWindowFocus';
import { useTransphereStatusStore } from '../stores/transphereStatusStore';

/**
 * Re-reads the shared Transphere status on every way back into the panel: AcombaGO announces neither
 * an activation nor a disablement, so what a consumer resolved on mount would otherwise stand for the
 * rest of the session. Desktop sessions have no status to read.
 */
export const useRevalidateTransphereStatus = (isAcomba: boolean): void => {
    const revalidate = useTransphereStatusStore(s => s.revalidate);
    const onReturn = useCallback(() => { if (!isAcomba) void revalidate(); }, [isAcomba, revalidate]);

    useRefreshOnVisible(onReturn);
    useRefreshOnPanelRestored(onReturn);
    useRefreshOnWindowFocus(onReturn);
};
